import LoadingIcon from './LoadingIcon';

export default LoadingIcon;
